export class MapReportModel {
  constructor(data = {}) {
    const {
      id,
      name,
      status,
      url = '',
      accountId,
      advertiserId,
      advertiserName,
      insertionOrderId,
      insertionOrderName,
      extractionStartDate = null,
      extractionEndDate = null,
      rejectReason = null,
      isAutoGenerated = false,
      createdTime,
      updatedTime,
    } = data
    this.id = id
    this.name = name
    this.status = status
    this.url = url
    this.accountId = accountId
    this.advertiserId = advertiserId
    this.advertiserName = advertiserName
    this.insertionOrderId = insertionOrderId
    this.insertionOrderName = insertionOrderName
    this.extractionStartDate = extractionStartDate
    this.extractionEndDate = extractionEndDate
    this.rejectReason = rejectReason
    this.isAutoGenerated = isAutoGenerated
    this.createdTime = createdTime
    this.updatedTime = updatedTime
  }

  static assign(data) {
    return new MapReportModel(data)
  }

  get extractionPeriod() {
    if (this.extractionStartDate === null && this.extractionEndDate === null)
      return '全期間'
    if (this.extractionStartDate === null) return `~ ${this.extractionEndDate}`
    if (
      this.extractionStartDate.toString().slice(0, 10) ===
      this.extractionEndDate.toString().slice(0, 10)
    )
      return this.extractionStartDate
    return `${this.extractionStartDate} ~ ${this.extractionEndDate}`
  }
}
